import { useState } from 'react'
import { MyTableCurrencyBanks, useCurrencyBankAccounts } from './columns'
import DataTable from '../../../../../components/Tables/GridTableMaterialUI/DataTable';
import { GridColDef } from '@mui/x-data-grid';

interface TableCurrencyBankAccountsProps {
  rowsCompanyBalance: MyTableCurrencyBanks[],
}

export const TableCurrencyBankAccounts = ({
  rowsCompanyBalance,
}: TableCurrencyBankAccountsProps) => {
  const { columnsCurrencyBankAccounts } = useCurrencyBankAccounts();
  const [columnsCurrency, setColumnsCurrency] = useState<GridColDef<MyTableCurrencyBanks>[]>(columnsCurrencyBankAccounts);

  return (
    <DataTable
      columns={columnsCurrency}
      setColumns={setColumnsCurrency}
      data={rowsCompanyBalance}
      entityId={"currency_id"}
      entity={`MyTableCurrencyBanks`}
      preferences={{}}
      namePreferences={"grid-currencybanks-columns"}
      nameOrderColumns={"grid-currencybanks-columns"}
      isChildren={true}
      hideFooter={true}
      hideShadow={true}
      disableColumnMenu={true}
    />
  )
}
